define('uikit/modules/dimmer2',['require','exports','module','underscore','backbone','marionette','../mixins/component.mixin','templates','../channel','../elements/header','../extra/static.methods','../definitions/modules/dimmer'],function(require, exports, module){
  var _              = require('underscore');
  var Backbone       = require('backbone');
  var Mn             = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates      = require('templates');
  var channel        = require('../channel');
  var HeaderView     = require('../elements/header');
  var StaticMethods  = require('../extra/static.methods');
  require('../definitions/modules/dimmer');

  var CenteredContentView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'content',

    template: function() { return '<div class="center"><ui name="contentView" /></div>'; },

    internalViewOptions: {
      contentView: function() {
        return _.extend({
          type: HeaderView,
          tagName: 'h2'
        }, Mn._getValue(this.getOption('content'), this))
      }
    }

  });

  var CloseDimmerBehavior = Mn.Behavior.extend({

    onFirstRender: function() {
      this.$el.addClass('deny');
    }

  });

  var Dimmer = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui dimmer',

    defaultDomElementVisibility: false,

    injectInternalViewsSynchronously: true,

    template: function() { return '<ui name="contentView" />'; },

    triggers: {
      'click .deny': {
        event: 'deny',
        stopPropagation: false,
        preventDefault: false
      }
    },

    options: {
      page     : false,
      disabled : false,
      inverted : false,

      // dimmer settings
      opacity: 'auto',
      closeable: false,
      useCSS: true,
      duration: { show : 500, hide : 500 },
      transition: 'fade'
    },

    internalViewOptions: {
      contentView: function() {
        return _.extend({
          type: CenteredContentView
        }, Mn._getValue(this.getOption('content'), this))
      }
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this.on('before:render', function() {
        this.insertIntoDom();
      })

      this.on('change:visible', function() {
        if (this.visible === true && !this.isRendered) {
          this.show({ force: true });
        }
      });

      this.on('deny', function() {
        this.visible = false;
      });

      if (this.getOption('visible') === true) {
        this.show({ force: true })
      }
    },

    insertIntoDom: function() {
      if (this.$el && this.getOption('page')) {
        $(document.body).prepend(this.$el);
      }
    },
    
    _show: function() {
      var self = this;
      if (!this.isRendered) { return this.render(); }
      this.$el.dimmer({
        // yes this is supposed to be closable and closeable
        closable   : this.getOption('closeable'),
        opacity    : this.getOption('opacity'),
        useCSS     : this.getOption('useCSS'),
        duration   : this.getOption('duration'),
        transition : this.getOption('transition'),
        onShow: function() {
          var options = {};
          self._setOption('visible', true, { internalVisibilityAction: true });
          self.triggerMethod('dimmer:show', self, options);
          self.triggerMethod('modal:show', self, options);
          self.triggerMethod('modal:visible', self, options);
        },
        onHide: function() {
          var options = {};
          self._setOption('visible', false, { internalVisibilityAction: true });
          self.triggerMethod('dimmer:hide', self, options);
          self.triggerMethod('modal:hide', self, options);
          self.triggerMethod('modal:hidden', self, options);
        }
      })
      .dimmer('show');
    },

    _hide: function() {
      if (!this.isRendered) { return; }
      this.$el.dimmer('hide');
    },

    updateAttributes: function() {
      this
          .addClass('page', this.getBoolOption('page'))
          .addClass('disabled', this.getBoolOption('disabled'))
          .addClass('inverted', this.getBoolOption('inverted'));
    }


  }, StaticMethods);

  Dimmer.CloseDimmerBehavior = CloseDimmerBehavior;

  channel.reply('dimmer2', function() {
    return Dimmer;
  });

  module.exports = Dimmer;
});
